import { speechCommandsEN } from "./speechCommands_en";

// load commands
const playerCommands = speechCommandsEN.player;

const player = '#JSGF V1.0; grammar player; public <player> = ' + playerCommands.join(' | ') + ';';

export const grammarEN = { player };